import axiosInstance from '../axiosInterceptor/axiosInstance'

const cancelSubscription = async (data) => {
  const { orgId } = data
  const url = `v1/orgs/${orgId}/billing/cancel`
  return axiosInstance.delete(url)
}

export default cancelSubscription
